var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartIconOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.43843 4.581C5.48165 3.53778 6.96172 2.98793 8.40834 3.20514C9.71185 3.40087 10.9494 4.21303 11.7971 5.76785C12.6448 4.21303 13.8824 3.40087 15.1859 3.20514C16.6325 2.98793 18.1126 3.53778 19.1558 4.581C20.2549 5.6801 20.5859 7.20592 20.4889 8.63901C20.392 10.0697 19.8664 11.461 19.1816 12.3421C17.8896 14.0047 17.4291 14.4953 16.26 15.6351C15.673 16.2075 14.9118 16.8758 14.3006 17.3985C13.9943 17.6604 13.7244 17.8868 13.531 18.0478C13.4343 18.1283 13.3567 18.1925 13.3032 18.2366L13.2417 18.2873L13.2318 18.2954C12.834 18.6871 12.315 18.883 11.7971 18.883C11.2792 18.883 10.7602 18.6871 10.3624 18.2954L10.3525 18.2873L10.291 18.2366C10.2375 18.1925 10.1599 18.1283 10.0632 18.0478C9.86984 17.8868 9.59995 17.6604 9.29367 17.3985C8.68242 16.8758 7.92119 16.2075 7.33419 15.6351C6.1651 14.4953 5.70463 14.0047 4.41258 12.3421C3.7278 11.461 3.20217 10.0697 3.10532 8.63901C3.0083 7.20592 3.33934 5.6801 4.43843 4.581Z",
    fill: "#F46940",
    stroke: "#F46940",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIconOn);
export default __webpack_public_path__ + "static/media/heartIconOn.4d5e5dff5a7514fd2968f6395aed2157.svg";
export { ForwardRef as ReactComponent };